import CustomerDrawer from "./CustomerDrawer"

export default CustomerDrawer
